import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const SystemLogApi = createApi({
  reducerPath: "SystemLogApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["SYSTEMLOGAPI"],
  endpoints: (build) => ({
    getSystemLogs: build.query({
      query: ({
        page = 1,
        limit = 20,
        action = "",
        userId = "",
        ip = "",
        startDate = "",
        endDate = "",
      }) => ({
        url: `/system-log?page=${page}&limit=${limit}&action=${action}&userId=${userId}&ip=${ip}&startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SYSTEMLOGAPI"],
    }),

    getSystemLogById: build.query({
      query: ({ id }) => ({
        url: `/system-log/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SYSTEMLOGAPI"],
    }),

    getSystemLogStats: build.query({
      query: ({ startDate = "", endDate = "" }) => ({
        url: `/system-log/stats?startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["SYSTEMLOGAPI"],
    }),

    createSystemLog: build.mutation({
      query: ({ data }) => ({
        url: `/system-log`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SYSTEMLOGAPI"],
    }),

    deleteSystemLog: build.mutation({
      query: ({ id }) => ({
        url: `/system-log/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SYSTEMLOGAPI"],
    }),

    cleanupOldLogs: build.mutation({
      query: ({ days = 90 }) => ({
        url: `/system-log/cleanup?days=${days}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["SYSTEMLOGAPI"],
    }),
  }),
});

export const {
  useGetSystemLogsQuery,
  useGetSystemLogByIdQuery,
  useGetSystemLogStatsQuery,
  useCreateSystemLogMutation,
  useDeleteSystemLogMutation,
  useCleanupOldLogsMutation,
  useLazyGetSystemLogsQuery,
  useLazyGetSystemLogByIdQuery,
  useLazyGetSystemLogStatsQuery,
} = SystemLogApi;
